'use client';

import { useRoadmapCategories } from '@/domain/roadmap/hooks';
import { type RoadmapCategory, type RoadMapUpdate } from '@/domain/roadmap/types';
import { Select } from '@andritzot/metris-web-ui/inputs/select';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';
import { FormControl } from '@andritzot/metris-web-ui/inputs/form-control';
import { InputLabel } from '@andritzot/metris-web-ui/inputs/input-label';
import { MenuItem } from '@andritzot/metris-web-ui/navigation/menu/menu-item';

interface CategoryFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function CategoryField({ viewOnly, control }: Readonly<CategoryFieldProps>) {
  const { data: categories = [] } = useRoadmapCategories();

  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="category"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper>
            <FormControl fullWidth size="small" disabled={viewOnly}>
              <InputLabel id="category-label">Category *</InputLabel>
              <Select
                labelId="category-label"
                label="Category"
                value={value ?? ''}
                onChange={(e) => onChange(Number(e.target.value))}
              >
                {categories.map((opt: RoadmapCategory) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
